import { combineReducers } from '@reduxjs/toolkit';

import userReducer from './userReducer';
import viewReducer from './viewReducer';

export default combineReducers({
  user: userReducer,
  view: viewReducer,
});
